'use client';
import React from 'react';
import { heroPhone, organizerBg } from './images';

import Image from 'next/image';
const HeroSection = () => {
  return (
    <div
      className='bg-black bg-cover bg-center object-cover pt-12 lg:pt-0'
      style={{ backgroundImage: `url(${organizerBg.src})` }}
    >
      <div className='mx-auto max-w-7xl px-12 sm:px-6'>
        <div className='flex flex-wrap items-center'>
          <div className='w-full text-center md:mt-0 md:w-7/12 md:text-left'>
            <div className='mb-12 text-white lg:mb-0 lg:max-w-[570px]'>
              <p className='text-2xl font-bold md:text-3xl lg:text-5xl lg:leading-[56px] xl:text-6xl xl:leading-[65px]'>
                Effortlessly go live with your event in a go!
              </p>
              <p className='mt-4 text-xs font-normal sm:font-semibold md:mt-2 lg:mt-8 lg:text-sm'>
                Empower your events, whether on-ground or digital, with our
                user-friendly platform loved by millions, making event creation
                and hosting a breeze.
              </p>
              <div className='h-12'></div>
              <a
                href='https://play.google.com/store/apps/details?id=com.fydo.eventorganiser&hl=en_IN&pli=1'
                className='mt-10 w-full cursor-pointer rounded-xl bg-[#FE3838] px-8 py-4 text-xs font-bold tracking-wider md:mt-8 md:w-auto lg:mt-14 lg:text-sm lg:leading-[24px]'
              >
                LIST YOUR EVENT
              </a>
            </div>
          </div>
          <div className='w-full px-4 md:w-5/12'>
            <div className='relative z-[1] mx-auto w-full max-w-[530px] pt-8 lg:mr-0'>
              <Image
                loader={(options) => options.src}
                src={heroPhone}
                alt='hero image'
                className='mx-auto max-w-full'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
